import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnDestroy, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IProductDataV2, IProductDataV3, Product } from '@df/catalog/product/product';
import { XnotifFormComponentDef } from '@df/module-xnotif/xnotif-form.component.def';
import { Xnotif } from '@df/module-xnotif/xnotif.interfaces';
import { TimeoutService } from '@df/ng/timeout.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../../ui/api/action.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { LocalProduct } from '../../catalog/model/product/product.decorator';
import { KlaviyoTrackingService } from '@df/klaviyo/klaviyo-tracking.service';

@Component({
    selector: 'xnotif-form',
    templateUrl: './xnotif-form.html',
    styleUrls: ['./xnotif-form.scss'],
    standalone: true,
    imports: [FormsModule, TranslationModule, InputWrapComponent, ActionComponent, NgStyle, InputWrapBodyDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class XnotifFormComponent extends XnotifFormComponentDef<LocalProduct<IProductDataV2>> implements OnDestroy {
    @Output()
    closeForm = new EventEmitter<void>();
    @Output()
    success = new EventEmitter<void>();
    private timeoutId?: number;
    private timeoutService = inject(TimeoutService);
    private klaviyoTrackingService = inject(KlaviyoTrackingService);
    onDataChange() {
        this.detectChanges();
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        clearTimeout(this.timeoutId);
    }
    protected override onSuccess(data: Xnotif.IData) {
        super.onSuccess(data);
        this.success.next();
        this.timeoutId = this.timeoutService.setTimeout(() => {
            this.closeForm.next();
            this.isSuccess = false;
            this.detectChanges();
        }, 2000);

        // track klavio
        this.klaviyoTrackingService.track('Back in stock notification sign-up', {
            sku: this.model.data!.sku
        });
    }
}
